<template>
	<div class="" @focus="onFocused">
		<input type="text" class="" ref="input" readonly />
	</div>
</template>
<script>
	import _ from 'lodash'

	export default {
		props: {
			options: { type: Object },
			modelValue: { type: String },
			small: { type: Boolean, default: false }
		},
		emits: ['update:modelValue', 'defaultValue', 'search-blur'],
		data() {
			return {
				settings: {
					placeholder: '-',
					separator: '/',
					minDate: '1300/01/01',
					maxDate: '1499/12/29',
					defaultValue: '',
					defaultValueMode: 'gregorian',
					stopOnEdges: true,
					rtl: false,
					pickerEnabled: true,
					pickerCss: '',
					pickerFocusable: false,
					iconPrefix: 'fa',
					viewMode: 'date',
					stayOnError: false,
					validValueAttr: 'data-gdate',
					keyHandler: null,
					pickerShortcut: {
						keyCode: 84,
						shiftKey: false,
						ctrlKey: false,
						altKey: false
					},
					required: false,
					useIsoFormat: true,
					events: {
						onclick: 'onclick',
						onblur: 'onblur',
						onchange: 'onchange',
						onfocus: 'onfocus',
						ondblclick: 'ondblclick',
						onkeydown: 'onkeydown',
						onkeyup: 'onkeyup',
						onrightedge: 'onrightedge',
						onleftedge: 'onleftedge'
					}
				},

				latest_start: 0,
				latest_end: 0,
				latest_value: '',

				stopChangeOnValue: false
			}
		},
		watch: {
			options: {
				handler(val) {
					this.cloneSettings(val)
				},
				deep: true
			}
		},
		computed: {

		},
		created() {
			this.cloneSettings(this.options)
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				var el = this.$refs.input
				var jel = $(el)
				jel.persianDatepicker({
					format: 'YYYY' + this.settings.separator + 'MM' + this.settings.separator + 'DD',
					timePicker: {
						enabled: true
					},
					autoClose: true,
					observer: true,
					toolbox: {
						calendarSwitch: {
							enabled: false
						}
					},
					viewMode: this.settings.viewMode,
					// initialValue: this.defaultValue(el),
					// initialValueType: this.defaultValueMode(el),
					onSelect: () => {
						this.emitValue(this.getValue())
						// this.check(el)
						setTimeout(() => {
						}, 100)
					}
				})
				var pdate = new Date(this.modelValue).toLocaleDateString('fa-IR')
				if (this.modelValue && pdate != null) {
					jel.attr('default', pdate)
					jel.attr('value', pdate)
				}
			},
			cloneSettings(options) {
				this.settings = _.extend({}, this.settings, options)
			},
			onFocused() {
				this.$refs.input.focus()
			},
			getValue() {
				let el = this.$refs.input
				return $(el).attr(this.settings.validValueAttr).split('T')[0]
				if (this.isValid(el)) {
				} else {
					return ''
				}
			},
			emitValue(value, defaultValue) {
				if (!this.settings.useIsoFormat || !value) {
					this.$emit('update:modelValue', value)
					if (this.settings.onChangeHandler && typeof (this.settings.onChangeHandler) === 'function') {
						this.settings.onChangeHandler(value)
					}
					if (defaultValue) { this.$emit('defaultValue', value) }
				} else {
					if (this.settings.separator !== '-') {
						var regex = new RegExp(this.settings.separator, 'g')
						value = value.replace(regex, '-')
					}
					var date = new Date
					var seconds = date.getSeconds()
					var minutes = date.getMinutes()
					var hour = date.getHours()
					value += `T${("00" + hour).slice(-2)}:${("00" + minutes).slice(-2)}:${("00" + seconds).slice(-2)}`
					this.$emit('update:modelValue', value)
					if (this.settings.onChangeHandler && typeof (this.settings.onChangeHandler) === 'function') {
						this.settings.onChangeHandler(value)
					}
					if (defaultValue) { this.$emit('defaultValue', value) }
				}
			},
			bindEvents(el) {
				var jel = $(el)
				var _vm = this
				let delayScroll = false

				jel.on('focus', function () {
					_vm.selectPartialText(el, 0, 4)

					jel.trigger(_vm.settings.events.onfocus)
				})
				jel.on('click', function (sender) {
					sender.preventDefault()
					_vm.fixSelection(el)
					_vm.updateGregorianValue(el)
					jel.trigger(_vm.settings.events.onclick)
				})
				jel.on('blur', function () {
					var empty = _vm.isEmpty(el)
					var required = _vm.isRequired(el)

					if (required && empty && _vm.settings.stayOnError === true) {
						jel.focus()
						return
					}

					var valid = _vm.isValid(el)

					if (!valid && _vm.settings.stayOnError === true) {
						jel.focus()
						return
					}

					_vm.updateGregorianValue(el)
					jel.trigger(_vm.settings.events.onblur)
					// _vm.destroyPicker(jel)
				})
				jel.on('dblclick', function () {
					jel.trigger(_vm.settings.events.ondblclick)
				})
				// jel.on('DOMMouseScroll mousewheel', function (event) {
				// 	event.preventDefault()
				// 	_vm.setDirty(el, true)

				// 	if (delayScroll) {
				// 		return
				// 	}

				// 	delayScroll = true
				// 	setTimeout(function () {
				// 		delayScroll = false
				// 	}, 100)

				// 	_vm.fixSelection(el)

				// 	if (event.originalEvent.wheelDelta < 0 || event.originalEvent.detail > 0) {
				// 		_vm.down(el)
				// 	} else {
				// 		_vm.up(el)
				// 	}

				// 	_vm.updateGregorianValue(el)
				// 	_vm.check(el)
				// })
				jel.on('paste input', function () {
					_vm.check(el)
				})

				var body = $('body')
				if (body.data('dateComponentBinded') == null) {
					body.data('dateComponentBinded', true)
					body.on('click', function (sender) {
						var That = $(sender.target)
						var wrapper = That.parents('.nikan-datetime-wrapper')
						var picker = That.parents('.datepicker-container')

						if (!wrapper.length && !picker.length) {
							// _vm.destroyAllPickers()
						}
					})
				}
			},
			getComponent(el) {
				var jel = $(el)
				var com = jel.data('component-date')

				return com || {}
			},
			emitValue(value, defaultValue) {
				if (!this.settings.useIsoFormat || !value) {
					this.$emit('update:modelValue', value)
					if (this.settings.onChangeHandler && typeof (this.settings.onChangeHandler) === 'function') {
						this.settings.onChangeHandler(value)
					}
					if (defaultValue) { this.$emit('defaultValue', value) }
				} else {
					if (this.settings.separator !== '-') {
						var regex = new RegExp(this.settings.separator, 'g')
						value = value.replace(regex, '-')
					}
					var date = new Date
					var seconds = date.getSeconds()
					var minutes = date.getMinutes()
					var hour = date.getHours()
					value += `T${("00" + hour).slice(-2)}:${("00" + minutes).slice(-2)}:${("00" + seconds).slice(-2)}`
					this.$emit('update:modelValue', value)
					if (this.settings.onChangeHandler && typeof (this.settings.onChangeHandler) === 'function') {
						this.settings.onChangeHandler(value)
					}
					if (defaultValue) { this.$emit('defaultValue', value) }
				}
			},
		},
	}
</script>
<style></style>
